module.exports = __webpack_public_path__ + "static/img/logo-fbt.c7cf4258.png";